/* eslint-disable id-length */
import _isNaN from 'lodash/isNaN';
import { add, rot, mid } from './util';
import validateLength from './validation';
import assetsPath from '../util/assetsPath';

const icon = `${assetsPath}/shapes/icons/icon_L-shape.svg`;
const labeledIcon = `${assetsPath}/shapes/labeledIcons/icon_L-shape.svg`;

const lShape = {
  label: 'L Shape',
  icon,
  labeledIcon,
  edges: [
    {
      key: 'a',
      shortLabel: 'A',
      longLabel: 'Side A',
      minLength: 1,
      maxLength: 999,
    },
    {
      key: 'b',
      shortLabel: 'B',
      longLabel: 'Side B',
      minLength: 1,
      maxLength: 999,
    },
    {
      key: 'c',
      shortLabel: 'C',
      longLabel: 'Side C',
      minLength: 1,
      maxLength: 999,
    },
    {
      key: 'd',
      shortLabel: 'D',
      longLabel: 'Side D',
      minLength: 1,
      maxLength: 999,
    },
  ],
  defaults: {
    edges: {
      a: {
        length: 26, isAgainstWall: false, hasBacksplash: false, backsplashHeight: '',
      },
      b: {
        length: 96, isAgainstWall: false, hasBacksplash: false, backsplashHeight: '',
      },
      c: {
        length: 72, isAgainstWall: false, hasBacksplash: false, backsplashHeight: '',
      },
      d: {
        length: 26, isAgainstWall: false, hasBacksplash: false, backsplashHeight: '',
      },
    },
    rotation: 270,
  },
  toPolygon: ({
    edges: {
      a, b, c, d,
    }, position, rotation,
  }) => {
    const poly = [
      { x: +a.length, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: +b.length },
      { x: +c.length, y: +b.length },
      { x: +c.length, y: +b.length - +d.length },
      { x: +a.length, y: +b.length - +d.length },
    ];
    return add(rot(poly, (-rotation * Math.PI) / 180, mid(poly)), position);
  },
  validate: ({ edges }) => {
    const errors = {
      a: [],
      b: [],
      c: [],
      d: [],
    };

    // Validate Lengths
    lShape.edges.forEach((e) => {
      const edge = edges[e.key];
      if (edge) {
        const lengthValidation = validateLength(edge.length, e.minLength, e.maxLength);
        if (lengthValidation) {
          errors[e.key].push(lengthValidation);
        }
        if (edge.hasBacksplash) {
          if (_isNaN(edge.backsplashHeight)) {
            errors[e.key].push('Backsplash Height is not valid');
          } else if (edge.backsplashHeight < 0) {
            errors[e.key].push('Backsplash Height cannot be negative');
          }
        }
        if (e.key === 'a') {
          const edgeC = edges.c;
          if (Number(edge.length) >= Number(edgeC.length)) {
            errors[e.key].push('Length should be less than C');
            errors.c.push('Length should be greater than A');
          }
        }

        if (e.key === 'd') {
          const edgeB = edges.b;
          if (Number(edge.length) >= Number(edgeB.length)) {
            errors[e.key].push('Length should be less than B');
            errors.b.push('Length should be greater than D');
          }
        }
      }
    });

    errors.messages = Object.keys(errors).map((edge) => {
      if (errors[edge].length) {
        const edgeMeta = lShape.edges.find((e) => e.key === edge);
        const message = errors[edge].join('. ');
        return { edge: edgeMeta.longLabel, message: `${message}.` };
      }
      return null;
    }).filter((x) => x);
    errors.isValid = !(errors.messages.length);
    return errors;
  },
};

export default lShape;
